import { useState } from 'react'

export default function AssignedAmountInput({ value, onCommit, min, max, ...props }) {
  const [draft, setDraft] = useState(null)
  return (
    <input
      {...props}
      type='text'
      inputMode='numeric'
      value={draft ?? ('$ ' + Number(value || 0).toLocaleString('es-CL'))}
      onFocus={() => setDraft(String(value ?? 0))}
      onBlur={() => setDraft(null)}
      onChange={event => {
        const digits = event.target.value.replace(/[^\d]/g, '')
        if (digits !== '' && ((min != null && Number(digits) < min) || (max != null && Number(digits) > max))) return
        setDraft(digits)
        if (digits === '' && min > 0) return
        onCommit(digits || '0')
      }}
    />
  )
}
